/* eslint-disable no-constant-condition */
import { takeEvery, /*take,*/ put, call, /*fork,*/ /*select,*/ all  } from 'redux-saga/effects'
import { invocatorServices } from '../services'
//import Cookies from 'js-cookie';
import {API_URL} from '../config/config'

import * as CONSTANTS from '../constants/constants'

export function* pings(){
  try {
    // console.log("ping payload: ", payload)
    const result = yield call(invocatorServices.getCall,`${API_URL}/pings`);
    yield put({type: CONSTANTS.PREFIX_PING_SUCCESS, response: result});
  } catch (e) {
    yield put({type: CONSTANTS.PREFIX_PING_ERROR, message: e.message});
  }
}



export default function* root() {
  
  yield takeEvery(CONSTANTS.PREFIX_PING_LOADING, pings)

  yield all([])
}

